import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

interface ICreateFolderParams {
    inputValue: string;
    createIn?: TFolderId | 'default';
}

export const createFolder = async ({
    inputValue,
    createIn = 'default',
}: ICreateFolderParams): Promise<IReturnResponse> => {
    // @ts-ignore
    const url = routable.getRoute('createFolder');
    const createInParsed = typeof createIn === 'string' ? createIn : String(createIn);
    try {
        // eslint-disable-next-line camelcase
        const { data } = await $api.post<IReturnResponse>(`${url}`, {
            name: inputValue,
            create_in: createInParsed,
        });
        return data;
    } catch (error) {
        console.log('createFolder error: ', error);
        return error;
    }
};
